import React, { useEffect, useState } from "react";
import { Form, Select, Button, Row, Col, Steps, DatePicker, message } from "antd";
import moment from "moment";
import configurationManagementService from "@services/configuationManagement.service";
import { useSocket } from "@components/SocketProvider";
import toast from "react-hot-toast";

const { Step } = Steps;
const { Option } = Select;

/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required!",
};
/* eslint-enable no-template-curly-in-string */

let interval = undefined;

const downloadFile = (url) => {
  const e = document.createElement("a");
  e.href = url;
  e.download = url.substr(url.lastIndexOf("/") + 1);
  document.body.appendChild(e);
  e.click();
  document.body.removeChild(e);
};

function Download() {
  // eslint-disable-next-line
  const socket = useSocket();

  const [submitted, setSubmitted] = useState(false);
  const [fileLink, setFileLink] = useState("");
  const [progress, setProgress] = useState(0);
  const [mos, setMos] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (submitted) {
      interval = setInterval(() => {
        setProgress((prev) => prev + 1);
      }, 100);
    } else {
      clearInterval(interval);
    }
  }, [submitted]);

  useEffect(() => {
    if (progress === 100 && fileLink) {
      setSubmitted(false);
      clearInterval(interval);
      downloadFile(fileLink);
    }
    // eslint-disable-next-line
  }, [progress]);

  const handleFormValuesChange = async (changedValues) => {
    const formFieldName = Object.keys(changedValues)[0];
    if (formFieldName === "vendor") {
      setMos([]);
      form.setFieldsValue({ mo_names: [] });
      try {
        const res = await configurationManagementService.fetchMoList({
          vendor: changedValues[formFieldName],
        });

        setMos(
          [...res.data].map((item, i) => (
            <Option key={i.toString(36) + i} value={item}>
              {item}
            </Option>
          ))
        );
      } catch (e) {
        console.log(e);
      }
    }
  };

  useEffect(() => {
    socket.on("progress", function (data) {
      // console.log("progress", data);
      // setProgress(data);
    });

    socket.on("message", function (data) {
      // console.log("message", data);
      if (data.s === 0) {
        setSubmitted(false);
        toast.error(data.message);
      }
    });
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    setProgress(0);
    setSubmitted(true);
    setFileLink("");
    try {
      const res = await configurationManagementService.downloadMoDump({
        ...values,
        mo_names: [...values.mo_names].join("|"),
        datetime: moment(values.datetime).toISOString(),
        io_id: socket.id,
      });

      setFileLink(res.data);
    } catch (err) {
      message.error("Action has error",20);
      console.log(err);
    }
  };

  return (
    <div className="bg-white rounded-md border border-gray-200 p-5">
      <Form
        form={form}
        layout="vertical"
        name="nest-messages"
        onFinish={onFinish}
        validateMessages={validateMessages}
        onValuesChange={handleFormValuesChange}
      >
        <Row gutter={[14, 0]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="vendor"
              label="Vendor"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select>
                <Option value="nokia">Nokia</Option>
                <Option value="huawei">Huawei</Option>
                <Option value="ericsson">Ericsson</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="mo_names"
              label="MO Name"
              rules={[
                {
                  type: "array",
                  required: true,
                  max: 4,
                },
              ]}
            >
              <Select
                mode="multiple"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Please select"
                maxTagCount={5}
              >
                {mos}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={4}>
            <Form.Item
              name="datetime"
              label="Date"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker className="w-full" format="" />
            </Form.Item>
          </Col>
          <Col flex="auto" className="flex justify-end items-end">
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                disabled={submitted}
                className="mt-4"
              >
                Download
              </Button>
              <Button
                style={{ margin: "0 8px" }}
                onClick={() => {
                  form.resetFields();
                }}
              >
                Clear
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {submitted && (
        <div className="mt-10">
          <Steps
            percent={progress}
            current={
              progress < 25 ? 0 : progress < 50 ? 1 : progress < 75 ? 2 : 3
            }
            direction="horizontal"
            className="mt-5"
          >
            <Step
              title={progress < 20 ? "In Progress" : "Finished"}
              description="Waiting for server response"
            />
            <Step
              title={
                progress < 25
                  ? "Waiting"
                  : progress < 50
                  ? "In Progress"
                  : "Finished"
              }
              description="Read from Database"
            />
            <Step
              title={
                progress < 50
                  ? "Waiting"
                  : progress < 75
                  ? "In Progress"
                  : "Finished"
              }
              description="Create Excel file"
            />
            <Step
              title={
                progress < 75
                  ? "Waiting"
                  : progress < 100
                  ? "In Progress"
                  : "Finished"
              }
              description="Download"
            />
          </Steps>
        </div>
      )}
    </div>
  );
}

export default Download;
